import _ from "lodash";
import dataService from "../../core/services/dataservice";

const MAX_CONCURRENT = 50;

export const useInventoryStore = defineStore("inventory", {
  state: () => {
    return {
      list: _mockList(),
      unitList: [],
      selectedStockId: {},
    };
  },
  getters: {
    getStockById: (state) => (stockId) => {
      return state.list.find((item) => item.stockId === stockId);
    },
    getStockComputed(state) {
      let groups = _.filter(this.list, (item) => item.level === 0);
      groups = _.sortBy(groups, ["order"]);

      //each type find groups
      let products: any[] = [];
      _.forEach(groups, (group) => {
        let items = _.filter(
          this.list,
          (item) => item.level === 1 && item.parentId === group.stockId
        );
        items = _.sortBy(items, ["order"]);
        products.push({
          ...group,
          items: items,
        });
      });

      return products;
    },
  },

  actions: {
    init() {
      this.fetch();
    },

    //
    async fetch() {
      let res = await dataService.inventories.getAll();
      this.list = res.data;
    },
    async insertBatch(items, callback) {
      try {
        let promises = [];
        for (let index = 0; index < items.length; index++) {
          const item = items[index];
          let p = dataService.inventories.post(item);
          promises.push(p);
        }
        let res = await Promise.all(promises);
      } catch (error) {
        console.log(error);
        alert(error);
      }
      this.fetch();
      callback && callback();
    },

    async updateBatch(item, callback) {
      await dataService.inventories.put(item);
      await this.fetch();
      callback && callback();
    },

    async removeBatch(item, callback) {
      await dataService.inventories.delete(item);
      await this.fetch();
      callback && callback();
    },
    transactionPost() {},
  },
});

function _mockList() {
  return [
    {
      name: "Alcohol",
      items: [
        { name: "Soda", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        { name: "Beer", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        { name: "Wine", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        { name: "Vodka", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        {
          name: "Whiskey",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        { name: "Rum", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        {
          name: "Tequila",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        { name: "Gin", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        {
          name: "Brandy",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        {
          name: "Liquor",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        {
          name: "Cognac",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        { name: "Cider", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        {
          name: "Liqueur",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        {
          name: "Champagne",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        {
          name: "Sparkling Wine",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        {
          name: "Sherry",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        { name: "Port", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
      ],
    },
    {
      name: "Alcohol",
      items: [
        { name: "Soda", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        { name: "Beer", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        { name: "Wine", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        { name: "Vodka", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        {
          name: "Whiskey",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        { name: "Rum", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        {
          name: "Tequila",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        { name: "Gin", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        {
          name: "Brandy",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        {
          name: "Liquor",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        {
          name: "Cognac",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        { name: "Cider", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
        {
          name: "Liqueur",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        {
          name: "Champagne",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        {
          name: "Sparkling Wine",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        {
          name: "Sherry",
          lastUpdate: "2123323",
          unit: "Can",
          min: 20,
          max: 40,
        },
        { name: "Port", lastUpdate: "2123323", unit: "Can", min: 20, max: 40 },
      ],
    },
    // More people...
  ];
}

const postItemsInBatches = async (items, dataservice) => {
  let maxConcurrent = 100,
    batchSize = 100;
  // Function to post an item to the database
  const postItem = async (item) => {
    try {
      // const response = await axios.post('http://example.com/api/item', item);
      const response = await dataservice(item);
      console.log(`Posted item. Response status: ${response.status}`);
    } catch (error) {
      console.error(`Error posting item: ${error.message}`);
    }
  };

  // Function to run the postItem function for each batch of items
  const runBatches = async (batches) => {
    for (let i = 0; i < batches.length; i++) {
      const batch = batches[i];

      // Create an array of promises for each item in the batch
      const promises = batch.map((item) => postItem(item));

      // Wait for all promises to fulfill before moving on to the next batch
      await Promise.all(promises);
    }
  };

  // Split the items array into batches of batchSize
  const batches = [];
  for (let i = 0; i < items.length; i += batchSize) {
    batches.push(items.slice(i, i + batchSize));
  }

  // Run the postItem function for each batch of items with a maximum of maxConcurrent concurrent requests
  const requests = [];
  for (let i = 0; i < batches.length; i++) {
    const batch = batches[i];

    // Create an array of promises for each item in the batch
    const promises = batch.map((item) => postItem(item));

    // Wait for all promises to fulfill before moving on to the next batch
    requests.push(Promise.all(promises));

    // Limit the number of concurrent requests
    if (requests.length >= maxConcurrent) {
      await Promise.all(requests);
      requests.length = 0;
    }
  }

  // Wait for any remaining requests to finish
  await Promise.all(requests);

};
